<template>
	<div v-show="dataList.length" class="module flex-column flex-center">
		<ul class="flex flex-betwee-end">
			<li v-for="(item, i) in dataList" :key="i" class="item flex-grow flex-column flex-end-center">
				<template v-if="item">
					<p v-if="item.index > 3">{{item.user_name}}</p>
					<img class="icon" :src="item.head_photo">
					<p v-if="item.index < 4">{{item.user_name}}</p>
					<img v-if="item.index < 4" class="trophy" :src="require(`@/assets/image/digital/trophy_${item.index}.png`)">
					<div class="sum" :class="{'z-active': target == item.index}">奖励：{{parseFloat(item.money)}}元</div>
				</template>
			</li>
		</ul>
		<img src="@/assets/image/digital/podium.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dataList: [],
				target: 1
			}
		},
		
		watch: {
			target: {
				handler(val) {
					setTimeout(() => {
						this.target = this.target == 5 ? 1 : this.target + 1
					}, 5000);
				},
				immediate: true
			}
		},

		methods: {
			update() {
				this.request({
					url: '/visual/data/brokerage/ranking',
					success: data => {
						this.dataList = [3, 1, 0, 2, 4].map(index => {
							if (data[index]) {
								data[index].index = index + 1;
							}
							return data[index];
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.module {
		padding: 0 .3rem;
		margin: 0 auto;
		
		ul {
			position: relative;
			width: 100%;
			margin-bottom: -.6rem;
			
			li {
				align-self: flex-end;
				position: relative;
				
				&:nth-child(1) {
					margin-bottom: .06rem;
				}
				
				&:nth-child(2) {
					margin-bottom: .3rem;
				}
				
				&:nth-child(3) {
					margin-bottom: .52rem;
				}
				
				&:nth-child(4) {
					margin-bottom: .18rem;
				}
				
				p {
					margin: .08rem 0;
					font-size: .13rem;
					color: #ABFFE9;
				}
				
				.icon {
					width: .36rem;
					height: .36rem;
					max-width: 30px;
					max-height: 30px;
					border: 1px solid #ABFFE9;
					border-radius: 50%;
				}
				
				.trophy {
					height: .6rem;
					max-height: 60px;
				}
				
				.sum {
					z-index: 1;
					position: absolute;
					left: 50%;
					top: -.38rem;
					padding: 0 .06rem;
					margin-left: -.12rem;
					line-height: .28rem;
					font-size: .13rem;
					white-space: nowrap;
					color: #fff;
					background: #F30000;
					opacity: 0;
					transition: opacity .3s ease;
					animation: sum 4s linear infinite;
					
					&.z-active {
						opacity: 1;
					}
					
					&:after {
						content: '';
						position: absolute;
						left: .08rem;
						bottom: -.05rem;
						border-top: .06rem solid #F30000;
						border-left: .06rem solid rgba(0,0,0,0);
						border-right: .06rem solid rgba(0,0,0,0);
					}
				}
			}
		}
	}

	@keyframes sum {
		0% {
			transform: translate(0,0);
		}

		25% {
			transform: translate(0,-.05rem);
		}

		75% {
			transform: translate(0,.05rem);
		}

		100% {
			transform: translate(0,0);
		}
	}
</style>